// import ReactGA from 'react-ga'
import ReactGA from 'react-ga4'

var is_ga_initialized = false

export const GAinit = () => {
    // Google Analytics Set Up
    is_ga_initialized = true
    const gaTrackingId = 'G-4TNP65TRBT'
    // const gaTrackingId = 'G-RK2YMSB51S'

    ReactGA.initialize(gaTrackingId)
}

export const GApage = () => {
    if (!is_ga_initialized) GAinit()
    // ReactGA.pageview(page)
    // ReactGA.send({ hitType: 'pageview', title: 'page' })

    // GAtrack('page', page, '')
}

export const GAtrack = (cat: string, action: string, label: string, value = -1) => {
    if (!is_ga_initialized) GAinit()
    ReactGA.event({
        category: cat,
        action: action,
        label: label,
        value: value
    })

    // if (cat === 'TxStatus' || cat === 'NewTx' || cat === 'wallet' || cat === 'page') {
    //     const wa = window.getStarknet?.()?.selectedAddress
    //     const network = networkId()
    //     if (wa && network) {
    //         // wallet is connected
    //         // create a new event
    //         ReactGA.event({
    //             category: 'user_flow',
    //             action: `${network}:${wa}`,
    //             label: action + ':' + label + ':' + Date.now()
    //         })

    //         if (action === 'REJECTED') {
    //             // special handling of rejects
    //             ReactGA.event({
    //                 category: 'rejectedTx',
    //                 action: `${network}:${wa}`,
    //                 label: label + ':' + Date.now()
    //             })
    //         }
    //     }
    // }
}

// eslint-disable-next-line no-unused-vars
export const GAbutton = (label: string) => {
    // console.log('label ', label)
    // GAtrack('button', 'click', label)
}
